import axios from "axios";
// import { notification } from "../controllers";

const servers = [
  {
    url: "Links",
    baseURL: "https://calculateservice.hoghooghyar.ir/",
    token: "419859111310089290494",
  },
  {
    url: "HaghVekalat",
    baseURL: "https://legalcalculations.hoghooghyar.ir/",
    token: "4198591113223792201602144855176",
  },
  {
    url: "KhesareatTakhir",
    baseURL: "https://calculateservice.hoghooghyar.ir/",
    token: "419859111310089290494",
  },
];

axios.interceptors.request.use(
  function (request) {
    const {baseURL,token} = servers.find((e) => request.url.search(e.url) !== -1)
    request.baseURL = baseURL
    request.headers.Token = token
    return request;
  },
  function (error) {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // let isStatus = error && error.response && error.response.status;
    // if (isStatus) {
    //   notification({ text: `خطای ${error.response.status}` });
    // } else {
    //   notification({ text: `خطا!` });
    // }
    return Promise.reject(error);
  }
);
export default axios;
